import { SubtemplateAccordion } from "PFApp/components/activity_form/multi_activity_form/subtemplate_accordion";
import { ActionType } from "PFApp/hooks/activity_form/multi_roles_form/use_actions_column";
import { useRolesFieldArray } from "PFApp/hooks/activity_form/multi_roles_form/use_roles_field_array";
import { useMultiActivityFormStoreActions } from "PFApp/stores/activity_form/multi_roles_form";
import { RoleFormKey, RolesFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { AccordionState } from "PFComponents/accordion";
import { Subtemplate } from "PFCore/types";
import { CSSProperties, useState } from "react";

import { AccordionContent } from "./accordion_content";

type SubtemplateContainerProps = {
  rolesFormKey: RolesFormKey;
  subtemplate: Subtemplate | null;
  leftPanelWidthCss: CSSProperties["width"];
  removeSubtemplate: () => void;
};

export const SubtemplateContainer = ({
  rolesFormKey,
  subtemplate,
  leftPanelWidthCss,
  removeSubtemplate
}: SubtemplateContainerProps) => {
  const { setAvailabilitySidePanelRoleFormKey } = useMultiActivityFormStoreActions();
  const { addRole, duplicateRole, removeRole } = useRolesFieldArray({
    rolesFormKey,
    removeSubtemplate
  });

  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  const handleAccordionStateChange = (state: AccordionState) => {
    setIsAccordionOpen(state === "open");
  };

  const handleAction = (roleFormKey: RoleFormKey, action: ActionType) => {
    switch (action) {
      // TODO: [SP-7181] Handle (Undo)MarkForRemoval action (not needed for MVP as we don't edit roles)
      case ActionType.Remove:
        removeRole(roleFormKey);
        break;
      case ActionType.BulkAddHours:
        setAvailabilitySidePanelRoleFormKey(roleFormKey);
        break;
      case ActionType.Duplicate:
        duplicateRole(roleFormKey);
        break;
    }
  };

  return (
    <SubtemplateAccordion
      addRole={addRole}
      subtemplate={subtemplate ?? null}
      onStateChange={handleAccordionStateChange}
    >
      <AccordionContent
        rolesFormKey={rolesFormKey}
        subtemplate={subtemplate}
        leftPanelWidth={leftPanelWidthCss}
        onAction={handleAction}
        isOpen={isAccordionOpen}
      />
    </SubtemplateAccordion>
  );
};
